import React from 'react';

import './App.css';
import { Container, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'dayjs/locale/en-gb';
import Lander from './pages/Lander';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

import TopBar from '@/components/TopBar';
import { theme } from '@/utils/Theme';
import Login from '@/pages/Login';
import ProtectedRoute from '@/utils/ProtectedRoute';
import Dashboard from '@/pages/Dashboard';
import KoriHaku from '@/pages/KoriHaku';
import { useAuthTokenManager } from '@/hooks/useAuthTokenManager';
import Kalenteri from '@/pages/Kalenteri';
import { useBackendHealth } from '@/hooks/useBackendHealth';
import UserInfo from '@/pages/UserInfo';

const App = () => {
  useAuthTokenManager();
  useBackendHealth();

  dayjs.extend(isoWeek);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <ThemeProvider theme={theme}>
        <Container
          disableGutters
          sx={{
            height: '100%',
            paddingBottom: '56px',
          }}
        >
          <TopBar />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            transition={Slide}
            theme="colored"
          />
          <Routes>
            <Route path="/" element={<Lander />} />
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route path="/koriHaku" element={<KoriHaku />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route path="/kalenteri" element={<Kalenteri />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route path="/kayttaja" element={<UserInfo />} />
            </Route>
          </Routes>
        </Container>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default App;
